import styled from 'styled-components';
import { getVariantTokens } from '../Button/Button.helpers';
import { useVariantCssObject } from '../Button/Button.hooks';
import { getOrientationStyles } from './ButtonGroup.helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledButtonGroup = styled.div.withConfig({
  displayName: "ButtonGroup__StyledButtonGroup",
  componentId: "sc-1sqz777-0"
})(({
  $orientation,
  $use
}) => {
  const variantTokens = getVariantTokens($use === 'default' ? 'neutral-default' : 'neutral-dark');
  if ($use === 'floating') {
    variantTokens.idle.borderColor = 'fill-accent-neutral-hover';
  }
  return Object.assign({}, getOrientationStyles($orientation), {
    display: 'inline-flex',
    flexDirection: $orientation === 'horizontal' ? 'row' : 'column',
    '> *': Object.assign({}, useVariantCssObject(variantTokens), {
      // Resolves issue with parts of focus ring on buttons being hidden by adjacent buttons
      '&:focus': {
        zIndex: 2
      }
    })
  });
});
export const ButtonGroup = ({
  children,
  use = 'default',
  orientation = 'horizontal'
}) => {
  return /*#__PURE__*/_jsx(StyledButtonGroup, {
    $use: use,
    $orientation: orientation,
    role: "group",
    children: children
  });
};